import type {
  options5,
  optionsInterface
} from "@dealer-center/ddc-pages-vin-decode-interface";

export interface optionsInterfaceOverride {
  title: string;
  options: options5[];
}

export const indexMapping = {
  options: 0,
  colors: 1,
  techSpecs: 2
};
export type indexMappingKeys = (typeof indexMapping)[keyof typeof indexMapping];

export type indexMappingString = keyof typeof indexMapping;
export const getIndexMappingValue = (key: indexMappingString) =>
  indexMapping[key];
export const getIndexMappingString = (key: number) => {
  const keys = Object.keys(indexMapping) as indexMappingString[];
  return keys.find(k => indexMapping[k] === key);
};
export function mapOptionsList(option: optionsInterface) {
  return option.options.map(option => {
    const returnValue: options5 = {
      ...option,
      msrPriceStr: option.msrPrice
        ? `$${option.msrPrice.toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
          })}`
        : "",
      invoicePriceStr: option.invoicePrice
        ? `$${option.invoicePrice.toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
          })}`
        : ""
    };

    return returnValue;
  });
}
